(() => {
  const initializeCarousel = (carousel) => {
    if (carousel.dataset.ridznaVideoReady === 'true') return;
    carousel.dataset.ridznaVideoReady = 'true';

    const viewport = carousel.querySelector('[data-ridzna-video-viewport]');
    const slides = [...carousel.querySelectorAll('[data-ridzna-video-slide]')];
    const dots = [...carousel.querySelectorAll('[data-ridzna-video-dot]')];
    if (!viewport || slides.length === 0) return;

    let activeIndex = -1;
    let pointerStart = 0;
    let scrollStart = 0;
    let dragging = false;
    let scrollFrame;

    const videos = slides.map((slide) => slide.querySelector('video'));

    videos.forEach((video) => {
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.playsInline = true;
      video.controls = false;
      video.loop = false;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
    });

    const playActiveVideo = () => {
      videos.forEach((video, index) => {
        if (!video) return;
        if (index === activeIndex) {
          const playPromise = video.play();
          if (playPromise) playPromise.catch(() => {});
        } else {
          video.pause();
        }
      });
    };

    const setActive = (index, shouldScroll = false) => {
      const nextIndex = Math.max(0, Math.min(index, slides.length - 1));
      const changed = nextIndex !== activeIndex;
      activeIndex = nextIndex;
      if (changed && videos[activeIndex]) videos[activeIndex].currentTime = 0;
      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', String(slideIndex !== activeIndex));
      });
      dots.forEach((dot, dotIndex) => {
        const selected = dotIndex === activeIndex;
        dot.classList.toggle('is-active', selected);
        dot.setAttribute('aria-pressed', String(selected));
      });
      if (shouldScroll) viewport.scrollTo({ left: activeIndex * viewport.clientWidth, behavior: 'smooth' });
      playActiveVideo();
    };

    const updateFromScroll = () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(() => {
        const index = Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1));
        if (index !== activeIndex) setActive(index);
      });
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => setActive(Number(dot.dataset.index), true));
    });

    viewport.addEventListener('scroll', updateFromScroll, { passive: true });
    viewport.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary) return;
      dragging = true;
      pointerStart = event.clientX;
      scrollStart = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture?.(event.pointerId);
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!dragging || !event.isPrimary) return;
      viewport.scrollLeft = scrollStart - (event.clientX - pointerStart);
    });
    const finishDrag = (event) => {
      if (!dragging || !event.isPrimary) return;
      const distance = event.clientX - pointerStart;
      const startingIndex = Math.round(scrollStart / Math.max(viewport.clientWidth, 1));
      dragging = false;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture?.(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      if (Math.abs(distance) >= 32) {
        setActive(Math.max(0, Math.min(startingIndex + (distance < 0 ? 1 : -1), slides.length - 1)), true);
      } else {
        setActive(Math.round(viewport.scrollLeft / Math.max(viewport.clientWidth, 1)), true);
      }
    };
    viewport.addEventListener('pointerup', finishDrag);
    viewport.addEventListener('pointercancel', finishDrag);

    videos.forEach((video, index) => {
      if (!video) return;
      video.addEventListener('ended', () => setActive((index + 1) % slides.length, true));
      video.addEventListener('canplay', () => {
        if (index === activeIndex && video.paused) playActiveVideo();
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach((video) => video?.pause());
      else playActiveVideo();
    });

    setActive(0);
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-ridzna-video-carousel]').forEach(initializeCarousel);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
